<template>
  <div class="list-add-card">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "add-card"
}
</script>

<style scoped>

</style>